module.exports = __webpack_public_path__ + "img/stationerywithname.94db869b.png";